import FadeIn from "../components/FadeIn";
import AnimCount from "../components/AnimCount";
import { ME } from "../constants/portfolioData";

/**
 * AboutSection
 * Bio text, stat counters, education card, and certifications.
 */
const AboutSection = () => {
  return (
    <>
      <style>{`
        #about { background: var(--bg2); }
        .about-grid { display: grid; grid-template-columns: 5fr 4fr; gap: 5rem; align-items: start; }
        .about-body { font-family: 'IBM Plex Sans', sans-serif; font-size: 0.975rem; line-height: 1.9; color: var(--muted2); }
        .about-body p { margin-bottom: 1.2rem; }
        .stats-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
        .stat-card { background: var(--bg3); border: 1px solid var(--border); border-radius: 10px; padding: 1.4rem; }
        .stat-n { font-family: 'IBM Plex Sans', sans-serif; font-size: 2.4rem; font-weight: 700; color: var(--text); line-height: 1; }
        .stat-suf { font-size: 1.1rem; color: var(--accent2); }
        .stat-l { font-family: 'IBM Plex Mono', monospace; font-size: 0.7rem; color: var(--muted); margin-top: 0.4rem; text-transform: uppercase; letter-spacing: 0.1em; }
        .edu-card { background: var(--bg3); border: 1px solid var(--border); border-radius: 10px; padding: 1.2rem 1.4rem; margin-top: 1rem; }
        .edu-school { font-weight: 600; font-size: 0.88rem; color: var(--text); }
        .edu-deg { font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--muted); margin-top: 0.25rem; }
        .cert-row { display: flex; flex-direction: column; gap: 0.5rem; margin-top: 1rem; }
        .cert { display: flex; align-items: flex-start; gap: 0.5rem; font-family: 'IBM Plex Mono', monospace; font-size: 0.75rem; color: var(--muted2); }
        .cert::before { content: '✓'; color: var(--green); flex-shrink: 0; margin-top: 0.05rem; }
      `}</style>

      <section id="about">
        <div className="wrap">
          <FadeIn><div className="sec-eyebrow">About Me</div></FadeIn>
          <FadeIn delay={0.05}>
            <h2 className="sec-title">
              Backend engineer.<br /><em>Systems thinker.</em>
            </h2>
          </FadeIn>

          <div className="about-grid">
            <FadeIn delay={0.1}>
              <div className="about-body">
                <p>
                  I’m a backend and platform engineer focused on building scalable, reliable systems.
                  With 6+ years of experience, I’ve worked across backend development, distributed systems, and
                  database infrastructure.
                </p>
                <p>
                  At Rakuten Group Inc., I work as a Database Engineer, developing and operating data platforms that
                  power large-scale production environments. My work spans system design, performance optimization,
                  and automation of database infrastructure.
                </p>
                <p>
                  I primarily work with Python and Django, along with databases like Cassandra, MySQL,
                  and PostgreSQL. I also build and manage cloud-native systems on AWS, with a focus on
                  automation, CI/CD, and operational excellence.
                </p>
                <p>
                  I enjoy tackling complex system challenges and building platforms that are not only scalable,
                  but also maintainable and efficient over time.
                </p>

                <div className="edu-card" style={{ marginTop: "2rem" }}>
                  <div className="edu-school">🎓 {ME.education.school}</div>
                  <div className="edu-deg">{ME.education.degree} · {ME.education.year}</div>
                </div>

                <div className="cert-row">
                  {ME.certifications.map((c) => (
                    <div key={c} className="cert">{c}</div>
                  ))}
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.2}>
              <div className="stats-grid">
                {ME.byTheNumbers.map((s) => (
                  <div key={s.label} className="stat-card">
                    <div className="stat-n">
                      <AnimCount n={s.n} />
                      <span className="stat-suf">{s.suffix}</span>
                    </div>
                    <div className="stat-l">{s.label}</div>
                  </div>
                ))}
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;